import { useState, createContext, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { selectUser } from '../reducers/UserReducer'
import { isSchoolUser } from '../utils/roles'
import { getInstitution, getOptionEnabledByInstitution } from '../utils/api/institution'
import { getIdOrNull } from '../utils'
import { InstitutionOptions } from '../utils/constants'

export const RequestPortalContext = createContext()

const RequestPortalProvider = ({ children }) => {
  const user = useSelector(selectUser)

  const [institution, setInstitution] = useState(null)
  const [allowLinkRequests, setAllowLinkRequests] = useState(undefined)
  const [isSchoolLinked, setIsSchoolLinked] = useState(undefined)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isSchoolUser(user) && getIdOrNull(institution)) {
      setLoading(true)

      getInstitution(user, institution).then(({ data }) => {
        setIsSchoolLinked(data.schools.find(s => getIdOrNull(s) === getIdOrNull(user.school)) !== undefined)
      })

      getOptionEnabledByInstitution(user, institution, InstitutionOptions.ALLOW_LINK_TO_SCHOOL_REQUESTS).then(({ data }) => {
        setAllowLinkRequests(data)
      })

      if (isSchoolLinked !== undefined && allowLinkRequests !== undefined) {
        setLoading(false)
      }
    }
  }, [allowLinkRequests, isSchoolLinked, user, institution])

  return (
    <RequestPortalContext.Provider value={{ allowLinkRequests, institution, isSchoolLinked, loading, setInstitution }}>
      {children}
    </RequestPortalContext.Provider>
  )
}

export default RequestPortalProvider
